import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  templateUrl: "./newsletter-unsubscribe-page.component.html",
  styleUrls: ["./newsletter-unsubscribe-page.component.scss"],
})
export class NewsletterUnsubscribePageComponent implements OnInit {
  key = this.route.snapshot.paramMap.get("code");

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {}
}
